import React, { useRef } from "react";
import "./MySkills.css";
import { motion } from "framer-motion";
import { Container, Row, Col, Image } from "react-bootstrap";

import MySkills from '../MySkills/MySkills';

import NavbarHeader from "../Navbarheader/NavbarHeader";

import MyTools from "./MyTools";
import Footer from "../Footer/Footer";

import aboutme from '../assets/aboutme.gif';

function getYearsOfExperience() {
  const startYear = 2020; // Change this to your actual starting year
  const currentYear = new Date().getFullYear();
  return currentYear - startYear;
}

function MySkillsPage() {

  const divRef = useRef(null);

  const scrollToDiv = () => {
    divRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div fluid style={{ height: 100 + "vh" }} className="scroll-container">
      <NavbarHeader />

      <Container fluid className="skillLandingPage">
        <Row>
          <Col xs={12} md={7} lg={7}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: -5 }}
              transition={{ duration: 0.5 }}
            >
              <h1 className="aboutHeadingxx">Skills</h1>
              <p
                style={{ lineHeight: 2 + "rem",fontFamily:'jost' }}
                className="aboutHeadingxxParagraph"
              >
                I'm a versatile product designer with over {getYearsOfExperience()} years of experience in 
                fintech, crypto, logistics, and enterprise sectors. My passion lies 
                in crafting innovative and user-centric solutions that bridge the gap 
                between complex technologies and seamless user experiences. From enterprise 
                platforms to consumer-facing applications, I specialize in creating intuitive, 
                visually appealing products that meet user needs and elevate overall user 
                satisfaction.
              </p>

              <svg
                onClick={() => scrollToDiv()}
                width="40"
                height="60"
                viewBox="0 0 93 172"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="animatedobject"
                  d="M72.0853 89L46.5484 116.097L19.6516 89C19.1207 89.0016 18.6004 89.1426 18.1465 89.4078C17.6927 89.673 17.3225 90.0523 17.0759 90.505C16.8293 90.9577 16.7156 91.4666 16.7471 91.9769C16.7785 92.4872 16.9538 92.9796 17.2542 93.4011L43.4711 129.866C44.5576 131.378 47.1735 131.378 48.2629 129.866L74.4798 93.4011C74.7833 92.9805 74.9612 92.4878 74.9944 91.9767C75.0275 91.4655 74.9145 90.9554 74.6677 90.5018C74.4208 90.0481 74.0496 89.6683 73.5944 89.4035C73.1391 89.1388 72.6172 88.9992 72.0853 89Z"
                  fill="#454545"
                />
                <rect
                  x="3.5"
                  y="3.5"
                  width="86"
                  height="165"
                  rx="41.5"
                  stroke="#454545"
                  stroke-width="7"
                />
              </svg>
            </motion.div>
          </Col>
          <Col className="d-flex justify-content-center align-items-center"
           style={{
                 display:"flex",
                alignItems: "center",
                justifyContent: "center",
               
              }} xs={12} md={5} lg={5}>
          
             
           
                <Image src={aboutme} className="aboutgiff" />
         
          
          </Col>
        </Row>
      </Container>
       
       <div ref={divRef}>
       <MySkills show={true} />
      <MyTools />
      <Footer />
      </div>
    </div>
  );
}

export default MySkillsPage;
